import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import es from "./locales/es.json";
import pt from "./locales/pt.json";

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: "en",
    resources: {
      en: { translation: en },
      es: { translation: es },
      pt: { translation: pt },
    },
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Order matters: cookie first, then localStorage, then browser language
      order: ["cookie", "localStorage", "navigator", "htmlTag"],
      // Look for these keys
      lookupCookie: "i18nextLng",
      lookupLocalStorage: "i18nextLng",
      // Cache the language selection
      caches: ["cookie", "localStorage"],
    },
  });

export default i18next;
